import axios from '../axios'
// 物料表列表
export const getBaseMaterialPage = (data) => {
  return axios({
    url: '/api/sys/base/material/getBaseMaterialPage',
    method: 'post',
    data
  })
}
//物料表列表保存
export const saveBaseMaterial = (data) => {
  return axios({
    url: '/api/sys/base/material/saveBaseMaterial',
    method: 'post',
    data
  })
}
// 物料表修改
export const updateBaseMaterial = (data) => {
  return axios({
    url: '/api/sys/updateBaseMaterial',
    method: 'post',
    data
  })
}
//修改物料条形码、国际码
export const updateBaseMaterialBarCode = (data) => {
  return axios({
    url: '/api/sys/updateBaseMaterialBarCode',
    method: 'post',
    data
  })
}
// 物料表删除
export const deleteBaseMaterials = (data) => {
  return axios({
    url: '/api/sys/base/material/deleteBaseMaterials',
    method: 'post',
    data
  })
}
// 同步第三方物料
export const downloadExternalMaterial = (data) => {
  return axios({
    url: '/api/sys/downloadExternalMaterial',
    method: 'post',
    data
  })
}
// 物料分组维护列表
export const getBaseMaterialGroupPage = (data) => {
  return axios({
    url: '/api/sys/getBaseMaterialGroupPage',
    method: 'post',
    data
  })
}
// 物料分组维护列表删除
export const deleteBaseMaterialGroups = (data) => {
  return axios({
    url: '/api/sys/deleteBaseMaterialGroups',
    method: 'post',
    data
  })
}
// 禁用物料分组
export const forbidBaseMaterialGroup = (data) => {
  return axios({
    url: '/api/sys/forbidBaseMaterialGroup',
    method: 'post',
    data
  })
}
// 启用物料分组
export const enabledBaseMaterialGroup = (data) => {
  return axios({
    url: '/api/sys/enabledBaseMaterialGroup',
    method: 'post',
    data
  })
}
// 同步第三方物料分类
export const downloadExternalMaterialGroup = (data) => {
  return axios({
    url: '/api/sys/downloadExternalMaterialGroup',
    method: 'post',
    data
  })
}
//  物料分组维护列表
export const saveBaseMaterialGroup = (data) => {
  return axios({
    url: '/api/sys/saveBaseMaterialGroup',
    method: 'post',
    data
  })
}
export const updateBaseMaterialGroup = (data) => {
  return axios({
    url: '/api/sys/updateBaseMaterialGroup',
    method: 'post',
    data
  })
}
// 物料库存表列表
export const getStkInventoryPage = (data) => {
  return axios({
    url: '/api/sys/stk/getStkInventoryPage',
    method: 'post',
    data
  })
}
// 物料库存表合计
export const getStkInventorySum = (data) => {
  return axios({
    url: '/api/sys/stk/getStkInventorySum',
    method: 'post',
    data
  })
}
// 物料库存表列表保存修改
export const saveStkInventory = (data) => {
  if (!data.id) {
    return axios({
      url: '/api/sys/stk/saveStkInventory',
      method: 'post',
      data
    })
  } else {
    return axios({
      url: '/api/sys/stk/updateStkInventory',
      method: 'post',
      data
    })
  }
}
// 品牌列表
export const getBaseBrandPage = (data) => {
  return axios({
    url: '/api/sys/base/getBaseBrandPage',
    method: 'post',
    data
  })
}
// 品牌列表 保存
export const saveBaseBrand = (data) => {
  return axios({
    url: '/api/sys/base/saveBaseBrand',
    method: 'post',
    data
  })
}
// 品牌列表 修改
export const updateBaseBrand = (data) => {
  return axios({
    url: '/api/sys/base/updateBaseBrand',
    method: 'post',
    data
  })
}
// 品牌列表 删除
export const deleteBaseBrands = (data) => {
  return axios({
    url: '/api/sys/base/deleteBaseBrands',
    method: 'post',
    data
  })
}
// 品牌列表 禁用 forbidStatus 1已禁用 0未禁用/启用
export const forbidBaseBrands = (data) => {
  return axios({
    url: '/api/sys/base/forbidBaseBrands',
    method: 'post',
    data
  })
}
// 品牌列表 查询单条记录信息
export const getBaseBrand = (data) => {
  return axios({
    url: '/api/sys/base/getBaseBrand',
    method: 'post',
    data
  })
}
// 物料库存表完整字段列表
export const getVStkInventoryMaterialPage = (data) => {
  return axios({
    url: '/api/sys/stk/getVStkInventoryMaterialPage',
    method: 'post',
    data
  })
}
// 物料分组树状列表
export const getBaseMaterialGroupTree = (data) => {
  return axios({
    url: '/api/sys/getBaseMaterialGroupTree',
    method: 'post',
    data
  })
}
// 14.商品停用/启用
export const deactivateBaseMaterial = (data) => {
  return axios({
    url: '/api/sys/deactivateBaseMaterial',
    method: 'post',
    data
  })
}
// 库存物料调整
export const inventoryAdjust = (data) => {
  return axios({
    url: '/api/sys/stk/inventoryAdjust',
    method: 'post',
    data
  })
}

// 商品大类列表
export const getBaseGoodCategoryPage = (data) => {
  return axios({
    url: '/api/sys/base/good/category/getBaseGoodCategoryPage',
    method: 'post',
    data
  })
}
// 商品大类列表 保存
export const saveBaseGoodCategory = (data) => {
  return axios({
    url: '/api/sys/base/good/category/saveBaseGoodCategory',
    method: 'post',
    data
  })
}
// 商品大类列表 修改
export const updateBaseGoodCategory = (data) => {
  return axios({
    url: '/api/sys/base/good/category/updateBaseGoodCategory',
    method: 'post',
    data
  })
}
// 商品大类列表 删除
export const deleteBaseGoodCategorys = (data) => {
  return axios({
    url: '/api/sys/base/good/category/deleteBaseGoodCategorys',
    method: 'post',
    data
  })
}
// 商品列表
export const getBaseGoodsPage = (data) => {
  return axios({
    url: '/api/sys/base/goods/getBaseGoodsPage',
    method: 'post',
    data
  })
}
// 商品列表 保存
export const saveBaseGoods = (data) => {
  return axios({
    url: '/api/sys/base/goods/saveBaseGoods',
    method: 'post',
    data
  })
}
// 商品列表 修改
export const updateBaseGoods = (data) => {
  return axios({
    url: '/api/sys/base/goods/updateBaseGoods',
    method: 'post',
    data
  })
}
// 商品列表 删除
export const deleteBaseGoodss = (data) => {
  return axios({
    url: '/api/sys/base/goods/deleteBaseGoodss',
    method: 'post',
    data
  })
}
// 商品列表 停启用
export const statusBaseGoodss = (data) => {
  return axios({
    url: '/api/sys/base/goods/statusBaseGoodss',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/Material.js